/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1
 */

export type AnalysisFileType = typeof AnalysisFileType[keyof typeof AnalysisFileType];


export const AnalysisFileType = {
  UpcomingBonusRewardsAnalysisFile: 'UpcomingBonusRewardsAnalysisFile',
  NewEmployeesAnalysisFile: 'NewEmployeesAnalysisFile',
  BoughtVouchersAnalysisFile: 'BoughtVouchersAnalysisFile',
  DirectPayoutAnalysisFile: 'DirectPayoutAnalysisFile',
  CompanyPensionAnalysisFile: 'CompanyPensionAnalysisFile',
  FullPayoutAnalysisFile: 'FullPayoutAnalysisFile',
} as const;
